import {useParams, useSearchParams} from 'react-router-dom';
import {
  ModuleEnum,
  PermissionOperationEnum,
  UserTypeEnum,
} from 'src/api/ProactApiClient';
import type {PersonnelViewType} from 'src/shared/constants/ViewTypes';
import {PersonnelForm} from 'src/app/personnel/PersonnelForm/PersonnelForm';
import {PersonnelDocumentTitle} from 'src/app/personnel/personnelHelpers';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';
import type {ViewModeType} from 'src/shared/services/RouterService/IRouteService';
import {PersonnelRouteService} from 'src/shared/services/RouterService/PersonnelRouteService';

import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';

export const EditPersonnelPage = () => {
  useSetDocumentTitle(PersonnelDocumentTitle);
  const {personnelId, view} = useParams();
  const [searchParams] = useSearchParams();

  const fromTabParam = searchParams.get('from');
  const fromTab = fromTabParam === 'all' ? 'all'
    : fromTabParam === 'activity' ? 'activity'
    : 'employee' as const;

  const mode: ViewModeType = 'edit';
  const router = new PersonnelRouteService(true, mode, {
    view: view as PersonnelViewType,
    fromTab,
  });

  return (
    <PersonnelForm
      mode="edit"
      userType={UserTypeEnum.Employee}
      id={+personnelId!}
      view={view as PersonnelViewType}
      enableEdit={true}
      router={router}
      fromTab={fromTab}
    />
  );
};

export default EditPersonnelPage;

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.PersonnelEdit(':personnelId', ':view'),
  element: <EditPersonnelPage />,
  module: ModuleEnum.Personnel,
  operation: PermissionOperationEnum.Update,
  isPrivate: true,
});
